<template>
  <div class="column">
    <div class="title text-brand-1">Filtros</div>

    <section class="row q-gutter-sm text-brand-1 text-weight-bold">
      <div
        style="width: 24%"
        class="q-ml-sm text-brand-5 text-weight-bold filtro-item"
      >
        Unidade:
        <lista-unidades-select
          v-model="filtros.unidade"
        ></lista-unidades-select>
      </div>
      <div
        style="width: 24%"
        class="q-ml-sm text-brand-5 text-weight-bold filtro-item"
      >
        Solicitante:
        <q-input dense outlined v-model="filtros.solicitante" />
      </div>
      <div
        style="width: 24%"
        class="q-ml-sm text-brand-5 text-weight-bold filtro-item"
      >
        Centro de Custo:
        <q-input dense outlined v-model="filtros.centro" />
      </div>
      <div
        style="width: 24%"
        class="q-mt-sm text-brand-5 text-weight-bold filtro-item"
      >
        Função / GHE:
        <q-input dense outlined v-model="filtros.ghe" />
      </div>
    </section>

    <section
      style="margin-top: 3px"
      class="row q-gutter-sm text-brand-1 text-weight-bold"
    >
      <div
        style="width: 24%"
        class="q-mt-sm q-ml-sm text-brand-5 text-weight-bold filtro-item"
      >
        Grupo Produto:
        <q-input dense outlined v-model="filtros.grupo" />
      </div>
      <div
        style="width: 24%"
        class="q-mt-sm q-ml-sm text-brand-5 text-weight-bold filtro-item"
      >
        Produto:
        <q-input dense outlined v-model="filtros.produto" />
      </div>
      <div
        style="width: 24%"
        class="q-mt-sm text-brand-5 text-weight-bold filtro-item"
      >
        Status:
        <q-select :options="tipos" v-model="filtros.status" dense outlined />
      </div>
      <div
        style="width: 24%"
        class="q-mt-sm text-brand-5 text-weight-bold filtro-item"
      >
        Regra Critica:
        <q-select
          :options="regraOptions"
          v-model="filtros.regra"
          dense
          outlined
        />
      </div>
      <div
        style="width: 24%"
        class="q-mt-sm q-ml-sm text-brand-5 text-weight-bold filtro-item"
      >
        Turno:
        <q-select
          v-model="filtros.turnos"
          :options="turnoOptions"
          option-value="id"
          option-label="description"
          emit-value
          map-options
          multiple
          use-chips
          dense
          outlined
          clearable
          :loading="loadingTurnos"
          placeholder="Todos os turnos"
        >
          <template v-slot:option="scope">
            <q-item v-bind="scope.itemProps">
              <q-item-section>
                <q-item-label>{{ scope.opt.description }}</q-item-label>
              </q-item-section>
            </q-item>
          </template>
        </q-select>
      </div>
    </section>
  </div>
</template>

<script>
import { ref, onMounted, watch } from "vue";
import ListaUnidadesSelect from "../../organizacional/unidade/component/ListaUnidadesSelect.vue";
import { watchDebounced } from "@vueuse/core";
import { useStore } from "vuex";
export default {
  components: { ListaUnidadesSelect },
  setup(props, { emit }) {
    const filtros = ref({
      solicitante: "",
      centro: "",
      unidade: "",
      status: "",
      produto: "",
      grupo: "",
      ghe: "",
      regra: "",
      turnos: [],
    });
    const store = useStore();
    const turnoOptions = ref([]);
    const loadingTurnos = ref(false);

    const getUnidade = () => {
      if (!store.state.org.unidadeData) {
        return;
      }
      filtros.value.unidade = store.state.org.unidadeData;
    };
    onMounted(getUnidade);

    const getTurnos = async () => {
      loadingTurnos.value = true;
      try {
        const response = await store.dispatch("simplificadoStore/getTurnos", {
          vendor_id: filtros.value.unidade?.id,
        });
        turnoOptions.value = response.data.results || [];
      } catch (error) {
        console.error("Erro ao carregar turnos:", error);
      } finally {
        loadingTurnos.value = false;
      }
    };
    onMounted(getTurnos);

    watchDebounced(
      [
        () => filtros.value.solicitante,
        () => filtros.value.centro,
        () => filtros.value.unidade,
        () => filtros.value.status,
        () => filtros.value.produto,
        () => filtros.value.grupo,
        () => filtros.value.ghe,
        () => filtros.value.regra,
        () => filtros.value.turnos,
      ],
      () => {
        emit("emitirFiltros", filtros.value);
      },
      { debounce: 400 }
    );

    watch(
      () => store.state.org.unidadeData,
      () => {
        if (store.state.org.unidadeData == null) {
          return;
        }
        filtros.value.unidade = store.state.org.unidadeData;
        getTurnos();
      }
    );

    watch(
      () => filtros.value.unidade,
      () => {
        filtros.value.turnos = [];
        getTurnos();
      }
    );

    return {
      filtros,
      turnoOptions,
      loadingTurnos,
      myLocale: {
        days: "Domingo_Segunda_Terça_Quarta_Quinta_Sexta_Sábado".split("_"),
        daysShort: "Dom_Seg_Ter_Quar_Quin_Sex_Sáb".split("_"),
        months:
          "Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro".split(
            "_"
          ),
        monthsShort: "Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez".split(
          "_"
        ),
        firstDayOfWeek: 1,
      },
      optionsFn(date) {
        var hoje = new Date();
        var ontem = new Date(hoje.getTime());
        ontem.setDate(hoje.getDate());
        var dd = ontem.getDate();
        var mm = ontem.getMonth() + 1;
        var yyyy = ontem.getFullYear();
        if (dd < 10) {
          dd = "0" + dd;
        }
        if (mm < 10) {
          mm = "0" + mm;
        }
        var data_ok = yyyy + "/" + mm + "/" + dd;
        return date <= data_ok;
      },
      tipos: [
        { label: "Todos", value: "" },
        { label: "Dentro do Prazo", value: "bloqueado" },
        { label: "Pode Trocar", value: "liberado" },
        { label: "Deve Trocar", value: "atrasado" },
        { label: "Nunca Retirado", value: "nunca_retirou" },
      ],
      regraOptions: [
        { label: "Todos", value: undefined },
        { label: "Sim", value: "critica" },
        { label: "Não", value: "nao_critica" },
      ],
    };
  },
};
</script>

<style scoped>
.title {
  margin-bottom: 15px;
  font-size: 1.25rem;
  margin-top: 20px;
}

@media (max-width: 600px) {
  .title {
    font-size: 1.2rem !important;
    text-align: center;
    margin-bottom: 16px;
  }

  .filtro-item {
    width: 100% !important;
    flex: 0 0 100% !important;
    max-width: 100% !important;
    margin: 0 0 16px 0 !important;
  }

  .filtro-item:last-child {
    margin: 0 0 16px 0 !important;
  }

  .filtro-item .q-field {
    width: 100% !important;
  }

  .filtro-item .q-select {
    width: 100% !important;
  }

  .filtro-item .q-input {
    width: 100% !important;
  }

  .row {
    flex-direction: column !important;
    gap: 0 !important;
  }

  .row .q-ml-sm {
    margin-left: 0 !important;
  }

  .row .q-mt-sm {
    margin-top: 0 !important;
  }
}

@media (max-width: 390px) {
  .title {
    font-size: 1.1rem !important;
  }

  .filtro-item {
    margin: 0 0 12px 0 !important;
  }

  .filtro-item:last-child {
    margin: 0 0 12px 0 !important;
  }
}
</style>
